/**
 * Company details used across the legal and contact pages.
 *
 * ⚠️ CONFIRM BEFORE PUBLISHING. Apple's organization enrolment checks that the
 * website is demonstrably associated with the registered entity, so the name
 * here must match the legal entity on the D-U-N-S record exactly, and the
 * address must be the registered business address.
 */
export const COMPANY = {
  /** Must match the registered legal entity name exactly. */
  legalName: 'GoGrov LLC',
  /** Trading name used in body copy. */
  tradingName: 'GoGrov',
  email: 'info@gogrov.com',
  /** Registered business address. Replace every line before publishing. */
  address: {
    line1: '[Street address]',
    line2: '',
    city: '[City]',
    region: 'Oregon',
    postcode: '[ZIP]',
    country: 'United States',
  },
  site: 'https://gogrov.com',
  /** Shown as "Last updated" on the policy pages. */
  lastUpdated: '30 July 2026',
} as const

/** True while any address line is still a placeholder. */
export const ADDRESS_INCOMPLETE = Object.values(COMPANY.address).some((v) =>
  v.startsWith('[')
)

export function formattedAddress(): string {
  const a = COMPANY.address
  return [a.line1, a.line2, `${a.city}, ${a.region} ${a.postcode}`, a.country]
    .filter(Boolean)
    .join('\n')
}
